<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button @click="(event) => handleButtonPress(event)">Scan Key</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search" />
            <svg class="filterIcon" width="32" height="26" viewBox="0 0 32 26" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="4" fill="#699991" rx="2" />
              <rect x="8" y="22" width="16" height="4" fill="#699991" rx="2" />
              <rect x="4" y="11" width="24" height="4" fill="#699991" rx="2" />
            </svg>
          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="(data) => {
          handleModal(selectedItem, data);
        }
          " :headers="headers"/>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../ContentHeader";
import * as Constants from "../../js/constants";
import EventBus from "../../eventBus";
import DataTable from "./pageComps/DataTable.vue";
import SearchBar from "./pageComps/Search.vue";
// import Insights from "../layout/Insights.vue";

export default {
  name: "GatePage",
  props: ["subPage", "organizationData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      communityId: "nautica2",
      showKeys: true,
      showIncidents: false,
      selectedItem: Constants.GATE,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      headerName: Constants.GATE,
      subHeader: "Here's a log of all keys sent for your Community.",
      page: this.subPage ? this.subPage : "",
      defaultFilters: {
        residentName: null,
        visitorName: null,
        subdivision: null,
        status: null,
        startTime: null,
        endTime: null
      },
      headers: [
        { text: "Visitor Name", value: "visitor_name", align: "start", sortable: true, width: 250 },
        { text: "Resident Name", value: "resident_name", filterable: true, width: 175 },
        { text: "Unit", value: "unit", width: 125 },
        { text: "Key Start Time", value: "time_active", filterable: false, width: 180 },
        { text: "Key Expiration Time", value: "expiration", filterable: false, width: 180 },
        { text: "Key Update Time", value: "time_active", filterable: false, width: 175 },
        { text: "Visitor Type", value: "visitor_relationship", filterable: false, width: 180 },
        { text: "Key Status", value: "current_status", filterable: false, width: 180 },
      ],
      totalKeys: 0,
      filters: {},
      tableData: [],
      search: "",
      cardInfo: [
        {
          title: "Total Keys Sent",
          value: "--",
          filters: {

          }
        },
        {
          title: "Total Keys Validated",
          value: "3",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "VALIDATED",
            startTime: null,
            endTime: null
          }
        },
        {
          title: "Total Keys Pending",
          value: "3",
        },
        {
          title: "Total Keys Denied",
          value: "1",
        },
        {
          title: "Party Keys Created",
          value: "30",
          filters: {
            residentName: "",
            visitorName: "",
            subdivision: "",
            status: "CREATED",
            startTime: null,
            endTime: null
          }
        }
      ],
    };
  },
  created() {
    console.log("Gate", this)
    this.changeView(this.selectedItem);
    EventBus.$on("keys", this.changeView);
    EventBus.$on("incidents", this.changeView);

    var date = new Date();
    this.defaultEndDate = date.toISOString().split("T")[0];
    var startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06";
    this.filters = this.defaultFilters

    // this.performSearch("").then((apiData) => {
    //   console.log("Finished getting and setting API Data", apiData)
    //   this.search = ""
    // });
    this.fetchAllKeys().then((data) => {
      this.tableData = data
      this.cardInfo[0].value = data.length

    });
  },
  watch: {
    search() {
      this.filters = this.defaultFilters
    },
    organizationData: function () {
      //this.communityId = newVal.organization_id
      this.communityId = "nautica2"
      this.fetchAllKeys()
    }
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal");
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    changeView(name) {
      console.log("Changing View from ", this.selectedItem, " to ", name);
    },
    fetchAllKeys() {
      if(this.communityId == undefined) {
        return
      }
      let url = `https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${this.communityId}/keys`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `GET`,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            resolve(data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    performSearch(data) {
      this.search = data
      let today = new Date().toISOString().split('T')[0]
      let url = `https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/${this.communityId}/keys/search?resident_name=${this.filters.residentName ?? data}&visitor_name=${this.filters.visitorName ?? data}&time_start=${this.filters.startTime ?? "2022-01-02"}&time_end=${this.filters.endTime ?? today}&status=${this.filters.status ?? data}&subdivision=${this.filters.subdivision ?? data}`
      return new Promise((resolve, reject) => {
        fetch(
          url,
          {
            method: `GET`,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            console.log("Search Data", data);
            this.tableData = data.data
            this.cardInfo[0].value = data.data.length
            resolve(data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateFiltersForSearchBasedOnCard(card) {
      this.filters = card.filters ?? this.defaultFilters
      this.performSearch(this.search).then(() => {
      })
    },
    handleButtonPress() {
      this.$modal.show(Constants.SCAN_KEY_MODAL)
    },
    openGateModal() {
      this.$modal.show(Constants.GATE_MODAL);
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration, data) {
      EventBus.$emit(Constants.UPDATE_KEY_MODAL_DATA, data)
      switch (configuration) {
        case Constants.GATE: {
          console.log("Opening Gate Modal")
          this.openGateModal();
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.filterIcon {
  margin-right: 16px;
}

input[type="text"]:focus {
  background-color: lightblue;
}

input[type="date"]:focus {
  outline: none;
  border: 0;
  appearance: none;
  border-width: 0px;
  border: none;
}

.pageHeader button {
  background-color: #1890FFCC !important;
}
</style>